import { Flame, Share2, X } from "lucide-react";
import { toast } from "sonner";

const MILESTONE_LABELS = {
  7: "One Week in Bloom",
  30: "A Month of Rhythm",
  100: "One Hundred Days of Becoming",
};
export { MILESTONE_LABELS };

export const MilestoneBadge = ({ days, bonusPoints, onClose, palette }) => {
  const label = MILESTONE_LABELS[days] || `${days} Days`;

  const share = async () => {
    const text = `I just reached a ${days}-day Daily Rhythm streak on Dandelion Farm: House of Bloom 🌼 — "${label}". Growing a little every day.`;
    if (navigator.share) {
      try {
        await navigator.share({ title: "House of Bloom", text });
        return;
      } catch (e) { /* fall through to clipboard */ }
    }
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Badge copied — paste it anywhere to share");
    } catch (e) {
      toast.error("Couldn't copy — long-press to share manually");
    }
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
      data-testid="milestone-badge-modal"
    >
      <style>{`
        @keyframes badge-pop { 0% { transform: scale(0.4) rotate(-6deg); opacity: 0; } 60% { transform: scale(1.06) rotate(1deg); } 100% { transform: scale(1) rotate(0deg); opacity: 1; } }
        @keyframes badge-glow { 0%, 100% { box-shadow: 0 0 30px #D9770655; } 50% { box-shadow: 0 0 55px #D9770699; } }
      `}</style>
      <div
        className="mx-6 max-w-sm w-full rounded-3xl p-8 text-center text-white relative"
        style={{ backgroundColor: "#0F766E", animation: "badge-pop 0.6s ease-out, badge-glow 2.5s ease-in-out infinite" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-white/10"
          aria-label="Close"
          data-testid="milestone-close-btn"
        >
          <X className="w-5 h-5" />
        </button>
        <div
          className="w-24 h-24 rounded-full mx-auto mb-5 flex flex-col items-center justify-center border-4"
          style={{ borderColor: "#D97706", backgroundColor: "#D9770622" }}
        >
          <Flame className="w-7 h-7" style={{ color: "#FCD34D" }} />
          <span className="text-xl font-bold" style={{ color: "#FCD34D" }} data-testid="milestone-days">{days}</span>
        </div>
        <p className="text-xs uppercase tracking-[0.25em] opacity-80 mb-1">Streak Milestone</p>
        <h3 className="text-2xl font-bold mb-2" style={{ color: "#FCD34D" }}>{label}</h3>
        <p className="text-sm opacity-85">
          {days} days of showing up for your rhythm. A golden bloom has been planted in your Self Garden.
        </p>
        {bonusPoints && (
          <p className="text-lg font-bold mt-3" style={{ color: "#FCD34D" }} data-testid="milestone-bonus">
            +{bonusPoints} bonus points
          </p>
        )}
        <div className="flex gap-3 mt-6">
          <button
            onClick={share}
            className="flex-1 rounded-full py-2.5 text-sm font-bold flex items-center justify-center gap-2"
            style={{ backgroundColor: "#D97706", color: "#FFFFFF" }}
            data-testid="milestone-share-btn"
          >
            <Share2 className="w-4 h-4" /> Share
          </button>
          <button
            onClick={onClose}
            className="flex-1 rounded-full py-2.5 text-sm font-bold border border-white/40"
            data-testid="milestone-done-btn"
          >
            Keep Growing
          </button>
        </div>
      </div>
    </div>
  );
};
